// extracted by mini-css-extract-plugin
export default {"mainBox":"Detail_mainBox__+BIUM","headerTitle":"Detail_headerTitle__sAeOP","classCard":"Detail_classCard__X6Pv6"};